export default __webpack_public_path__ + "static/media/personalizza-dark.7bf5486c.svg";